import { useState } from "react";

import { useAuth } from "./useAuth";

import { apiRoot } from "../constants";

const useMessages = () => {
  const { token } = useAuth();
  const [error, setError] = useState(false);

  const createMessage = (data) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/messages`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Token " + token,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status !== 201) {
            setError(true);
            return;
          }
          return response.json();
        })
        .then((json) => {
          res(json);
        })
        .catch((err) => {
          setError(true);
        });
    });
  };

  return {
    createMessage,
    error,
  };
};

export default useMessages;
